import spartaEventsUtility from "utilities/global/sparta-events-utility/2.3.5/js/sparta-events-utility";
import jQuery from "utilities/vendor/jquery/3.5.1/js/jquery";
import $ from "utilities/vendor/jquery/3.5.1/js/jquery";
































; 

class SpartaMaskingUtility {
  init(getOptions = true) {
    const maskingClassBase = this.data.globals.MASKING_CLASS_BASE;



    if (getOptions) {
      this.fn.core.addMasking($(`.${maskingClassBase}`));
    }
  }

  get data() {
    return data;
  }

  get fn() {
    return fn;
  }
}

const spartaMaskingUtility = new SpartaMaskingUtility();


const data = {

  globals: {

    PAGE_LANGUAGE: 'enUS',

    MASKING_CLASS_BASE: 'gis-mask',

    MASKING_CLASS_ORIGINAL: 'gis-mask-original',

    MASKING_CLASS_READY: 'gis-mask-value',

    MASKED_FIELD_SUFFIX: '-masked',


    MASKING_CHARACTER: '\u25CF',

    FULL_MASK_TOGGLE_SUFFIX: '-cbToggleFullMask',

    AUTO_RE_MASK_INPUT_PREFIX: 'remaskInputDelay_',

    AUTO_RE_MASK_TEXT_PREFIX: 'remaskTextDelay_',

    ADA_MASKING_TEXT: {
      enUS: '<span class="ada-hidden">This value has been hidden for security reasons</span>',
      esUS: '<span class="ada-hidden">Este valor ha sido ocultado por razones de seguridad</span>',
    },

    ADA_MASK_ACTION: {
      enUS: ' <span aria-hidden="true" class="masking-action">Hide</span>',
      esUS: ' <span aria-hidden="true" class="masking-action">Ocultar</span>',
    },

    ADA_UNMASK_ACTION: {
      enUS: '<span class="ada-hidden">Activate link to</span> <span class="masking-action">Show</span> <span class="ada-hidden">this value (the value will be hidden again in 5 seconds)</span>',
      esUS: '<span class="ada-hidden">Activar vínculo para </span> <span class="masking-action">Mostrar</span> <span class="ada-hidden">este valor (el valor se ocultará otra vez en 5 segundos)</span>',
    },
  },


  maskingPatterns: {
    allChars: /./g,

    alphaNumeric: /[a-z\d]/gi, 
  },
  timeOuts: {},
};


const fn = {


  helpers: {















    applyMask(sValue, sPattern, sMaskType) {
      const aPatternMatch = sValue.match(new RegExp(sPattern));



      let sMaskedPortion = sValue;



      let regexMaskPattern = spartaMaskingUtility.data.maskingPatterns.allChars;

      if (aPatternMatch) {
        sMaskedPortion = aPatternMatch[0];
      }

      if (Object.prototype.hasOwnProperty.call(
        spartaMaskingUtility.data.maskingPatterns, sMaskType
      )) {
        regexMaskPattern = spartaMaskingUtility.data.maskingPatterns[sMaskType];
      }


      const sMaskedValue = sMaskedPortion.replace(regexMaskPattern,
        spartaMaskingUtility.data.globals.MASKING_CHARACTER);


      return sValue.replace(sMaskedPortion, sMaskedValue);
    },




    hideElement($element, bHideElement) {
      $element.toggleClass('spa-hidden', bHideElement).attr('aria-hidden', bHideElement);
    },
  },



  core: {












    addMasking($maskingGroup) {

      const sPageLanguage = $('html').attr('lang') ? $('html').attr('lang').replace(/[^a-z]/gi, '') :
        'enUS';

      if (spartaMaskingUtility.data.globals.PAGE_LANGUAGE !== sPageLanguage) {
        spartaMaskingUtility.data.globals.PAGE_LANGUAGE = sPageLanguage;
      }


      spartaMaskingUtility.fn.core.addInputMasking($maskingGroup.filter(':input'));
      spartaMaskingUtility.fn.core.addTextMasking($maskingGroup.not(':input'));
    },













    addInputMasking($inputGroup) {
      $inputGroup.each(function () {

        const $inputField = $(this);
        const sInputMaskId = $inputField.attr('id')
          + spartaMaskingUtility.data.globals.MASKED_FIELD_SUFFIX;
        let $inputMask = $(`#${sInputMaskId}`);


        if ($inputMask.length === 0) {


          $inputMask = $inputField.clone();



          $inputField.addClass(spartaMaskingUtility.data.globals.MASKING_CLASS_ORIGINAL);



          $inputMask.attr('id', sInputMaskId)
            .attr('name', $inputField.attr('name') +
            spartaMaskingUtility.data.globals.MASKED_FIELD_SUFFIX)



            .removeClass(spartaMaskingUtility.data.globals.MASKING_CLASS_BASE)
            .addClass(spartaMaskingUtility.data.globals.MASKING_CLASS_READY)



            .bind('focus.gisMasking', function () {
              const $maskedField = $(this);
              const sMaskId = $maskedField.attr('id');



              const sRemaskId = spartaMaskingUtility.data.globals.AUTO_RE_MASK_INPUT_PREFIX
                + sMaskId;
              clearTimeout(spartaMaskingUtility.data.timeOuts[sRemaskId]);


              spartaMaskingUtility.fn.helpers.hideElement($maskedField, true);


              const sSourceInputId = sMaskId
                .replace(spartaMaskingUtility.data.globals.MASKED_FIELD_SUFFIX, '');
              const $sourceInput = $(`#${sSourceInputId}`);

              spartaMaskingUtility.fn.helpers.hideElement($sourceInput, false);
              $sourceInput.focus().select();


              $(`label[for="${sMaskId}"]`).attr('for', sSourceInputId);
            })
            .bind('mousedown.gisMasking', function () {


              $(this).trigger('click');
            });


          spartaMaskingUtility.fn.helpers.hideElement($inputMask, true);


          $inputField.after($inputMask);
        }



        $(this).bind('blur.gisMasking', function () {
          spartaMaskingUtility.fn.core.maskInputData($(this), 200);
        });



        spartaMaskingUtility.fn.core.maskInputData($(this), 0);
      });
    },












    maskInputData($element, iDelay) {
      const sCurrVal = $.trim($element.val());




      if ((sCurrVal !== '') && (sCurrVal !== $element.attr('placeholder'))) {

        const sMaskingType = $element.data('field-type');

        const sInputMaskId = $element.attr('id')
          + spartaMaskingUtility.data.globals.MASKED_FIELD_SUFFIX;
        const $inputMask = $(`#${sInputMaskId}`);



        let sMaskingFunctionName = 'basic';

        if (Object.prototype.hasOwnProperty.call(
            spartaMaskingUtility.fn.maskingRules, sMaskingType
        )) {
          sMaskingFunctionName = sMaskingType;
        }


        spartaMaskingUtility.fn.helpers.hideElement($element, true);


        $(`label[for="${$element.attr('id')}"]`).attr('for', sInputMaskId);


        spartaMaskingUtility.fn.helpers.hideElement($inputMask, false);


        $inputMask.val(sCurrVal);


        const sRemaskId = spartaMaskingUtility.data.globals.AUTO_RE_MASK_INPUT_PREFIX
          + sInputMaskId;
        spartaMaskingUtility.data.timeOuts[sRemaskId] = setTimeout(() => {
          $inputMask.val(spartaMaskingUtility.fn.maskingRules[sMaskingFunctionName](sCurrVal));
        }, iDelay);
      }
    },













    addTextMasking($textGroup) {
      $textGroup.each(function () {

        const $textField = $(this);
        const $parentWrapper = $(this).closest('.masked-element');
        let $textMask = $parentWrapper
          .find(`.${spartaMaskingUtility.data.globals.MASKING_CLASS_READY}`);

        if ($textMask.length === 0) {


          $textMask = $textField.clone();



          $textField.addClass(spartaMaskingUtility.data.globals.MASKING_CLASS_ORIGINAL);


          $textField.attr('role', 'button');
          $textMask.attr('role', 'button');




          $textMask.removeClass(spartaMaskingUtility.data.globals.MASKING_CLASS_BASE)
            .addClass(spartaMaskingUtility.data.globals.MASKING_CLASS_READY);


          spartaMaskingUtility.fn.helpers.hideElement($textMask, true);

          const sMaskingType = $textField.data('field-type');
          let sMaskingFunctionName = 'basic';

          if (Object.prototype.hasOwnProperty.call(
            spartaMaskingUtility.fn.maskingRules, sMaskingType
          )) {
            sMaskingFunctionName = sMaskingType;
          }


          $textMask.find('.masking-value')
            .text(spartaMaskingUtility.fn.maskingRules[sMaskingFunctionName](
              $textField.find('.masking-value').text()
            ));


          $textField.after($textMask);


          $textField.append(spartaMaskingUtility.data.globals.ADA_MASK_ACTION[
            spartaMaskingUtility.data.globals.PAGE_LANGUAGE
          ]);

          $textField.bind('click.mask', function () {
            spartaMaskingUtility.fn.core.maskTextValue($textField);
          });


          const sCurrentValue = $textMask.html();
          $textMask.html(`<span aria-hidden='true'>${sCurrentValue}</span`);


          $textMask.prepend(spartaMaskingUtility.data.globals.ADA_MASKING_TEXT[
            spartaMaskingUtility.data.globals.PAGE_LANGUAGE
          ]);
          $textMask.append(spartaMaskingUtility.data.globals.ADA_UNMASK_ACTION[
            spartaMaskingUtility.data.globals.PAGE_LANGUAGE
          ]);

          $textMask.bind('click.unmask', function () {
            spartaMaskingUtility.fn.core.unmaskTextValue($textMask, 5000);
          });


          spartaMaskingUtility.fn.core.unmaskTextValue($textMask, 0);
        }
      });
    },




    maskTextValue($element) {

      const sRemaskId = spartaMaskingUtility.data.globals.AUTO_RE_MASK_TEXT_PREFIX
        + $element.closest('.masked-element').attr('id');
      window.clearTimeout(spartaMaskingUtility.data.timeOuts[sRemaskId]);


      const sMaskingType = $element.data('field-type');
      let sMaskingFunctionName = 'basic';

      if (Object.prototype.hasOwnProperty.call(
        spartaMaskingUtility.fn.maskingRules, sMaskingType
      )) {
        sMaskingFunctionName = sMaskingType;
      }

      const $maskedField = $element.closest('.masked-element').find(
        `.${spartaMaskingUtility.data.globals.MASKING_CLASS_READY}`
      );
      $maskedField.find('.masking-value')
        .text(spartaMaskingUtility.fn.maskingRules[sMaskingFunctionName](
          $element.find('.masking-value').text()
        ));


      spartaMaskingUtility.fn.core.changeTextMask($element, true);
    },




    unmaskTextValue($element, iDelay) {

      spartaMaskingUtility.fn.core.changeTextMask($element, false);


      const sRemaskId = spartaMaskingUtility.data.globals.AUTO_RE_MASK_TEXT_PREFIX
        + $element.closest('.masked-element').attr('id');
      spartaMaskingUtility.data.timeOuts[sRemaskId] = window.setTimeout(() => {
        spartaMaskingUtility.fn.core.changeTextMask($element, true);
      }, iDelay);
    },




    changeTextMask($element, bMaskValue) {
      const $parentWrapper = $element.closest('.masked-element');


      const $dataField = $parentWrapper.find(
        `.${spartaMaskingUtility.data.globals.MASKING_CLASS_ORIGINAL}`
      );
      const $maskedField = $parentWrapper.find(
        `.${spartaMaskingUtility.data.globals.MASKING_CLASS_READY}`
      );


      spartaMaskingUtility.fn.helpers.hideElement($dataField, bMaskValue);
      spartaMaskingUtility.fn.helpers.hideElement($maskedField, !bMaskValue);

      $parentWrapper.find('a:visible').focus();
    },
  },



  maskingRules: {








    basic(sValue) {
      const sInputPattern = '^.+$'; 
      const sMaskingPattern = 'allChars';

      return spartaMaskingUtility.fn.helpers.applyMask(sValue, sInputPattern, sMaskingPattern);
    },









    email(sEmailValue) {


      const sMaskedPortion = sEmailValue.split('@')[0];

      let sMaskedValue = sMaskedPortion;
      const sMaskedPortionLength = sMaskedPortion.length;


      if (sMaskedPortionLength < 3) {
        sMaskedValue = spartaMaskingUtility.fn.maskingRules.basic(sMaskedPortion);
      } else {


        const sSubstringPortion = sMaskedPortion.substring(1, (sMaskedPortionLength - 1));
        const sMaskedSubstringValue = spartaMaskingUtility.fn.maskingRules.basic(sSubstringPortion);

        sMaskedValue = sMaskedPortion.charAt(0) + sMaskedSubstringValue
          + sMaskedPortion.charAt(sMaskedPortionLength - 1);
      }

      return sEmailValue.replace(sMaskedPortion, sMaskedValue);
    },









    phone(sPhoneValue) {
      const sInputPattern = '^.+(?=.{4}$)'; 
      const sMaskingPattern = 'alphaNumeric';

      return spartaMaskingUtility.fn.helpers.applyMask(sPhoneValue, sInputPattern, sMaskingPattern);
    },










    account(sAccountValue) {
      const sInputPattern = '^.+(?=.{4}$)'; 
      const sMaskingPattern = 'allChars';

      return spartaMaskingUtility.fn.helpers.applyMask(
        sAccountValue, sInputPattern, sMaskingPattern
      );
    },









    date(sDateValue) {
      const sInputPattern = '^.+$'; 
      const sMaskingPattern = 'alphaNumeric';

      return spartaMaskingUtility.fn.helpers.applyMask(sDateValue, sInputPattern, sMaskingPattern);
    },










    ssn(sSSNValue) {
      const sInputPattern = '^.+$'; 
      const sMaskingPattern = 'alphaNumeric';

      return spartaMaskingUtility.fn.helpers.applyMask(sSSNValue, sInputPattern, sMaskingPattern);
    },
  },
};

export default spartaMaskingUtility;
